// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"52":"c8b21b27","112":"d5d65c1c","120":"dfd13f81","257":"b7abe287","318":"f58df3b6","359":"9e6657ec","453":"8ed179bb","626":"f6fa07b0","653":"2b3aec6d","669":"eecbe9c4","822":"72094a9f","830":"de8a8480","919":"7306531d","987":"1d7db001"}[chunkId] + ".js";
};